import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Header from "../Header";

/* IMPORT PROTECTED PAGES */
import { ProtectedRoutes } from "./RouterSecurity";
import { UserPage } from "../../pages/UserPage";
import Home from "../../pages/Home";

/* IMPORT PUBLIC PAGES */
import SignIn from "../../pages/SignIn";
import SignUp from "../../pages/SignUp";
import Projects from "../../pages/Portfolio";
import Skills from "../../pages/Skills";

export const Router = () => {
  return (
    <>
      <BrowserRouter>
        <Header />

        <Routes>
          <Route path="/" element={<Home />} exact />

          {/* PROTECTED ROUTES  */}
          <Route element={<ProtectedRoutes />}>
            <Route path="/user-page" element={<UserPage />} />
          </Route>

          {/* PUBLIC ROUTES */}
          <Route path="/home" exact element={<Home />} />
          <Route path="/signin" exact element={<SignIn />} />
          <Route path="/signup" exact element={<SignUp />} />
          <Route path="/portfolio" exact element={<Projects />} />
          <Route path="/skills" exact element={<Skills />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};
